import type {
  InterstateOnChangeEvent,
  MuiSxProps,
  TextInputEventValue
} from "@dealer-center/core-components";
import { TextInput } from "@dealer-center/core-components";

import styled from "styled-components";
import type { stringInputs } from "..";
import { configItemContext } from "..";
import { useContext } from "react";
import {
  StyledIconInfoOutline,
  StyledImport,
  StyledImportedText,
  StyledInput,
  StyledInputWrapper
} from "./styles";

export interface PagesInventoryConfigUiConfigDispayInputStringInterface {
  item: stringInputs;
  className?: string;
  sx?: MuiSxProps;
}
const StyledTextInput = styled(TextInput)<{
  imported: boolean;
  importExists: boolean;
}>`
  ${StyledInput}
`;

export const ConfigInput = ({
  item,
  className,
  sx
}: PagesInventoryConfigUiConfigDispayInputStringInterface) => {
  const {
    curentConfig,
    setCurrentConfigValue,
    importedConfig,
    selectedConfig
  } = useContext(configItemContext);
  const currentConfigItem = curentConfig[item.dataIndex] as string;
  const importedConfigItem = importedConfig?.[item.dataIndex] as string;
  const selectedConfigItem = selectedConfig?.[item.dataIndex] as string;
  const isUsingImportedValue =
    currentConfigItem === importedConfigItem &&
    currentConfigItem !== selectedConfigItem;
  const onChange = (e: InterstateOnChangeEvent<TextInputEventValue>) => {
    setCurrentConfigValue({
      key: item.dataIndex,
      value: e.target.value
    });
  };
  return (
    <StyledInputWrapper className={className}>
      <StyledTextInput
        disabled={item.disabled || false}
        id={item.dataIndex}
        importExists={importedConfig !== undefined}
        imported={isUsingImportedValue}
        label={item.label}
        name={item.dataIndex}
        size="small"
        sx={sx}
        value={currentConfigItem}
        onChange={onChange}
      />
      {isUsingImportedValue && (
        <StyledImport>
          <StyledIconInfoOutline title="Using imported value" />
          <StyledImportedText>Using imported value</StyledImportedText>
        </StyledImport>
      )}
    </StyledInputWrapper>
  );
};
